import { render, staticRenderFns } from "./relatedOrders.vue?vue&type=template&id=3023b417&scoped=true"
import script from "./relatedOrders.vue?vue&type=script&lang=js"
export * from "./relatedOrders.vue?vue&type=script&lang=js"
import style1 from "./relatedOrders.vue?vue&type=style&index=1&id=3023b417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023b417",
  null
  
)

export default component.exports